import React from "react"
import { EditFeatureFormValues, FeatureStatus, UserPlan } from "../featuresTypes"
import { StandardForm } from "../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../shared/components/forms/StandardMainPanel"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { FormikDropdown, FormikSwitch, FormikTextField } from "../../../../../shared/components/forms/Formik"
import { StandardSidePanel } from "../../../../../shared/components/forms/StandardSidePanel"
import { MenuItem } from "@mui/material"
import { iterateStringEnum } from "../../../../../lib/enums"

export function EditFeatureFormContent() {
    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict id="support-admin-feature-edit-programmatic-id-label" attrs={{ label: true }}>
                    <FormikTextField<EditFeatureFormValues> disabled name="progId" label="Programmatic ID" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="support-admin-feature-edit-name-label" attrs={{ label: true }}>
                    <FormikTextField<EditFeatureFormValues> name="name" label="Name" fullWidth />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="support-admin-feature-edit-settings-title" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="support-admin-feature-edit-enabled-label">
                        <FormikSwitch name="isEnabled">Enabled:</FormikSwitch>
                    </LocalizedStrict>

                    <LocalizedStrict id="support-admin-feature-edit-plan-label" attrs={{ label: true }}>
                        <FormikDropdown<EditFeatureFormValues> name="plan" label="Plan">
                            {[...iterateStringEnum(UserPlan)].map((value) => (
                                <MenuItem key={value} value={value}>
                                    <LocalizedEnum base="support-admin-features-table-plan" enumValue={value}>
                                        <span>{value}</span>
                                    </LocalizedEnum>
                                </MenuItem>
                            ))}
                        </FormikDropdown>
                    </LocalizedStrict>

                    <LocalizedStrict id="support-admin-feature-edit-status-label" attrs={{ label: true }}>
                        <FormikDropdown label="Status" name="status">
                            {[...iterateStringEnum(FeatureStatus)].map((value) => (
                                <MenuItem key={value} value={value}>
                                    <LocalizedEnum base="support-admin-features-status" enumValue={value}>
                                        <span>{value}</span>
                                    </LocalizedEnum>
                                </MenuItem>
                            ))}
                        </FormikDropdown>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
        </StandardForm>
    )
}
